export default "/assets/images/basic-breather2.b306387a33f12abe.png";